<template>
    <div>
        <h1>附件</h1>
        <span>{{attachmentSize}}/10</span>
        <div v-for="(item,index) in resumeInfo.attachmentList">
            <div>
                <span>{{item.name}}</span>
                <span>{{item.file}}</span>
                <span>----</span>
                <span>{{fileName(item.file)}}</span>
                <br/>
                <span>{{item.description}}</span>
            </div>
        </div>
        <el-divider></el-divider>
    </div>
</template>
<script>
    export default {
        name: 'attachment',
        props: ['resumeInfo'],
        data () {
            return {
            };
        },
        computed: {
            // 截取文件名
            fileName(){
                return function(file){
                    if (file!=null) {
                        return file.substring(file.lastIndexOf("/")+1, file.length);
                    }
                }
            },
            // 简历附件列表数量
            attachmentSize(){
                return this.size();
            }
        },
        methods: {
            // 计算简历工作经历数量
            size(){
                var attachmentSize = 0;
                for(var i in this.resumeInfo.attachmentList) {
                    attachmentSize++;
                }
                return attachmentSize;
            },
        }
    }
</script>